import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  CategoryType,
  Color,
  GetProdutcsResult,
  Loading,
  Product,
  ProductsFailure,
  ProductsRepository,
  Size,
  Sort,
} from "../domain";
import { ServiceLocater, Services } from "../service-locater";
import { AppThunk } from "./store";

type ProductsListState = {
  loading: Loading;
  failure?: ProductsFailure;
  products: Product[];
  productsCount: number;
  pageSize: number;
};

const initialState: ProductsListState = {
  loading: "idle",
  products: [],
  pageSize: 0,
  productsCount: 0,
};

const productsListSlice = createSlice({
  name: "productsList",
  initialState,
  reducers: {
    produtcsListLoading(state) {
      state.failure = undefined;
      state.loading = "pending";
    },
    produtcsListLoaded(state, { payload }: PayloadAction<GetProdutcsResult>) {
      state.products = payload.products;
      state.productsCount = payload.productsCount;
      state.pageSize = payload.pageSize;
      state.loading = "succeeded";
    },
    produtcsListFailed(state, { payload }: PayloadAction<ProductsFailure>) {
      state.failure = payload;
      state.loading = "failed";
    },
  },
});

export default productsListSlice.reducer;

const {
  produtcsListFailed,
  produtcsListLoaded,
  produtcsListLoading,
} = productsListSlice.actions;

export const loadProdutcsList = (
  categoryId: string,
  categoryType: CategoryType,
  page: number,
  selectedSizes: Size[],
  selectedColors: Color[],
  selectedSort: Sort
): AppThunk => async (dispatch) => {
  dispatch(produtcsListLoading());
  const res = await ServiceLocater.get<ProductsRepository>(
    Services.ProductsRepository
  ).getProducts(
    categoryId,
    categoryType,
    page,
    selectedSizes,
    selectedColors,
    selectedSort
  );
  res.fold(
    (l) => {
      dispatch(produtcsListFailed(l));
    },
    (r) => {
      dispatch(produtcsListLoaded(r));
    }
  );
};
